export default {
    googlePlayAppLink: 'https://play.google.com/store/apps/details?id=musclebooster.workout.home.gym.abs.loseweight',
    appStoreAppLink: 'https://apps.apple.com/us/app/workouts-by-muscle-booster/id1446447749',
};
